module.exports = __webpack_public_path__ + "media/comboSmash-preview@lg-0d7b590003dc0522e12e3d63b2ea89a5.jpg";